import type { GuideManifest } from '@farmer1st-seeds/guides-ui'

export type ApprovalActor = { email: string | null; at: string | null; legacy: boolean } | null
export type GuideCounts = { guides: number; sequences: number; durationS: number; bytes: number }
export type GuideRevision = {
  seed: string; seedVersion: string; revision: number; approved: boolean; visible: boolean
  everApproved: boolean; manifestHash: string | null; committedAt: string | null
  approvalRowVersion: number; approvedBy: ApprovalActor; objectsState: 'active' | 'pruned' | 'broken'
  objectsPrunedAt: string | null; counts: GuideCounts; shown: boolean; resolutionReason: string | null
  reviewStatus?: 'pending' | 'unapproved'
}
export type GuideVersion = {
  seedVersion: string
  policy: { enabled: boolean; revisionMode: 'latest_approved' | 'pinned'; pinnedRevision: number | null; rowVersion: number; source: string }
  shown: boolean; resolutionReason: string; selectedRevision: number | null; approvedBy: ApprovalActor
  counts: GuideCounts; revisions: GuideRevision[]
}
export type GuideSeedDetail = {
  seed: string; displayName: string
  settings: { visibleVersionLimit: number; rowVersion: number; source: string }
  shownTuples: string[]
  versions: GuideVersion[]
}
export type GuideSeedSummary = { seed: string; displayName: string; guideCount: number; pendingCount: number; versionCount: number; resolvedCount: number; visibleVersionLimit: number; shownVersions: string[] }
export type ApprovalImpact = { before: string[]; after: string[]; willBeVisible: boolean; message: string; policyRepair: null | { enabled: boolean; revisionMode: 'latest_approved'; pinnedRevision: null; reason: string } }
export type ApprovalPreflight = { impact: ApprovalImpact; impactToken: string; approvalRowVersion: number; manifestHash: string | null }
export type GuidePreviewManifest = GuideManifest

export async function apiJson<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, init)
  const body = await response.json().catch(() => ({})) as T & { error?: string }
  if (!response.ok) throw Object.assign(new Error(body.error || `HTTP ${response.status}`), { status: response.status, body })
  return body
}

export const formatBytes = (bytes: number) => bytes ? `${(bytes / 1048576).toFixed(1)} MB` : '—'
export const formatMinutes = (seconds: number) => seconds ? `${Math.max(1, Math.round(seconds / 60))} min` : '—'
export const formatDate = (value: string | null) => value ? new Date(value).toLocaleString() : '—'
